import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    /*const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }*/
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  drugShortageCounts: [],
  notSelectedItemsCounts: [],
  checkLists: [],
  errorStatus: null,
  totalPages: 0,
  totalRecords: 0,
  checkListDetails: null,
};
const getters = {
  getApiLoad_8: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_DrugShortageCount(state, checkLists) {
    state.drugShortageCounts = checkLists;
  },
  SET_NotSelectedItemsCount(state, checkLists) {
    state.notSelectedItemsCounts = checkLists;
  },
  SET_CheckLists(state, data) {
    state.checkLists = data.items;
    state.totalPages = data.totalPages;
    state.totalRecords = data?.totalRecords ?? 0;
  },
  SET_ChecklistDetails(state, details) {
    state.checkListDetails = details;
  },
};
const actions = {
  errorCheckList({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getDrugShortageCount({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/CheckLists/DrugShortageCount', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DrugShortageCount', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCheckList', error);
      });
  },
  getNotSelectedItemsCount({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/CheckLists/NotSelectedItemsCount', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_NotSelectedItemsCount', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCheckList', error);
      });
  },
  getListOfCheckListsWithPagination(
    { commit, dispatch, rootState },
    {
      fromDate,
      toDate,
      vehicleId,
      seniorTechnicianId,
      previousSeniorTechnicianId,
      drugId,
      notSelectedCategoryItemId,
      isActive,
      pageNumber,
      pageSize,
    },
  ) {
    let url = '/CheckLists/ReportPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (vehicleId) {
      url += '&VehicleId=' + vehicleId;
    }
    if (seniorTechnicianId) {
      url += '&SeniorTechnicianId=' + seniorTechnicianId;
    }
    if (previousSeniorTechnicianId) {
      url += '&PreviousSeniorTechnicianId=' + previousSeniorTechnicianId;
    }
    if (drugId) {
      url += '&DrugId=' + drugId;
    }
    if (notSelectedCategoryItemId) {
      url += '&NotSelectedCategoryItemId=' + notSelectedCategoryItemId;
    }
    if (isActive) {
      url += '&IsActive=' + isActive;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_CheckLists', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCheckList', error);
      });
  },
  getDetailOfCheckListReportDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/CheckLists/Report', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_ChecklistDetails', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCheckList', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
